'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.run = run;

var _base = require('@cycle/base');

var _base2 = _interopRequireDefault(_base);

var _mostAdapter = require('@cycle/most-adapter');

var _mostAdapter2 = _interopRequireDefault(_mostAdapter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cycle = function Cycle(main, drivers) {
  return (0, _base2.default)(main, drivers, { streamAdapter: _mostAdapter2.default });
};

function run(main, drivers) {
  return (0, _base2.default)(main, drivers, { streamAdapter: _mostAdapter2.default }).run();
}

Cycle.run = run;

exports.default = Cycle;


/** WEBPACK FOOTER **
 ** ./~/@cycle/most-run/lib/index.js
 **/